import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import Cookies from "js-cookie";
import config from "../config";
import { getCached, setCached, invalidateCache } from "./cacheStore";

class WASLDriverStore {
  WASLDriverArray = [];
  WASLDriverName = [];
  CompanyIdentityNumbers = [];
  WASLDriverStatus = [];
  waslactivity=[];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      WASLDriverArray: observable,
      WASLDriverName: observable,
      WASLDriverStatus: observable,
      CompanyIdentityNumbers: observable,
      total: observable,
      loading: observable,
      loadData: action,
      registerDriver: action,
      toGetDriverName: action,
      getDriverInfo: action,
      deleteRecord: action,
      getWASLDriverStatus: action,
      getWASLDriverActivity:action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    searchField,
    offset,
    limit,
    UcompanyId,
    pageNo,
  }) {


    const cacheKey = `driverList:${offset}:${limit}:${searchField}:${companyId}:${UcompanyId}:${pageNo}`;
    const cached = getCached(cacheKey);
        
    if (cached) {
      this.WASLDriverArray = cached.WASLDriverArray;
      this.total = cached.total;
      return;
    }

    this.loading = true;
    var postData = {
      companyId: companyId,
      searchField: searchField,
      offset: offset,
      limit: limit,
      page: pageNo,
      UcompanyId: UcompanyId,
    };
    var base64Input = await base64_encode(JSON.stringify(postData));
     if(config.pythonReport==1){
       var response = await postApi
      .getClient()
      .post(config.NodeUrl+"/driver/wasldriverlist", postData);
    }
    else{
          var response = await postApi
            .getClient()
            .post("index.php?c=wasl&a=driverList", "postData=" + base64Input);
    }

    const WASLDriverArray = response?.data?.data?.wasldriver;
    const total = parseInt(response?.data?.data?.TotalCount);

    setCached(cacheKey, { WASLDriverArray, total });
    
    this.WASLDriverArray = WASLDriverArray;
    this.total = total;
    this.loading = false;
  }

  async registerDriver(data) {
    var postData = data;
    console.log(postData);
    const base64Input = await base64_encode(JSON.stringify(postData));

    if(config.pythonReport==1){
          var response = await postApi
          .getClient()
          .post(config.NodeUrl+ "/driver/wasldriverregister", postData);
    }
    else{
          var response = await postApi
          .getClient()
          .post("index.php?c=wasl&a=registerDriver", "postData=" + base64Input);
    }
    //    this.total = parseInt(response?.data?.data?.TotalCount);
    return response;
  }

  async getCompanyIdentityNo(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getIdentityNo", "postData=" + base64Input);

    console.log(response.data.data);

    // this.CompanyIdentityNumbers = parseInt(response?.data?.data);
    this.CompanyIdentityNumbers = response?.data?.data;
    return response;
  }

  // To get driver name
  async toGetDriverName(companyId) {
    // console.log(companyId,"dwee")
    var postData = {
      tokenId: "",
      companyId: companyId,
      isadmin: -1,
      deviceGrpOffSet: 0,
      deviceGrpSize: 10,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=getdata", "postData=" + base64Input);
    console.log(response, "response");
    this.WASLDriverName = response?.data?.data?.company[0]?.drivers;
    console.log(this.WASLDriverName);
    // this.total = parseInt(response?.data?.data?.TotalCount);
    return response;
  }

  async getDriverInfo(driverId) {
    console.log("driverId", driverId);
    var postData = { driverId: driverId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=getDriverInfo", "postData=" + base64Input);
    console.log(response);

    this.total = parseInt(response?.data?.data?.TotalCount);
    return response.data.data;
  }

  async deleteRecord({ Id, companyId, waslDriverKey, userId }) {
    var postData = {
      Id: Id,
      companyId: companyId,
      waslDriverKey: waslDriverKey,
      userId: userId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

     if(config.pythonReport==1){
       var response = await postApi
      .getClient()
      .post( config.NodeUrl + "/driver/wasldriverdelete", postData);
    }
    else{
        
      var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=deleteDriver", "postData=" + base64Input);
    }
    return response;
  }
  async getWASLDriverStatus(record) {
    var postData = { Id: record.Id, waslDriverKey: record.waslDriverKey };

    const base64Input = await base64_encode(JSON.stringify(postData));
    if(config.pythonReport==1){
      var response = await postApi
      .getClient()
      .post(config.NodeUrl+"/driver/wasldriverstatus",postData);

      console.log("LLLLLLLLLLLL",response?.data);

       if (response?.data?.data?.resultCode) {
            this.WASLDriverStatus =response?.data?.data.resultCode;
            response = "";
          } else if (response?.data?.data) {
            this.inquiryStatus = response?.data?.data;
            console.log("Ahgdashkg",response?.data?.data)
          } else {
            this.WASLDriverStatus = response?.data?.message;
            response = "";
          }   
    }
    else{
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=wasl&a=getwasldriverstatus",
        "postData=" + base64Input
      );

    if (JSON.parse(response?.data?.data)?.resultCode) {
      this.WASLDriverStatus = JSON.parse(response?.data?.data).resultCode;
      response = "";
    } else if (response?.data?.data) {
      this.inquiryStatus = JSON.parse(response?.data?.data);
    } else {
      this.WASLDriverStatus = response?.data?.errors[0][0];
      response = "";
    }
  }

    return response?.data;
  }

  // async exportExcel(getData) {
  //   console.log("getData", getData);
  //   if(config.pythonReport==1){
  //     var response = await postApi
  //     .getClient("")
  //     .post(config.NodeUrl+"/driver/exportwaslexcel", {
  //       postData:getData
  //     });
  //     return response?.data;
  //   }
  //   else{
  //       let lang = "english";
  //       window.location.href =
  //         baseURL +
  //         "index.php?c=wasl&a=exportwasldriverexcel&cid=" +
  //         getData.cid +
  //         "&UcompanyId" +
  //         getData.UcompanyId +
  //         "&colList=" +
  //         getData.colList +
  //         "&searchField=" +
  //         getData.searchField +
  //         "&language=" +
  //         lang;
  //   }
   
  // }
  async exportExcel(getData) {
 
  if(config.pythonReport==1){
    try {
      const response = await postApi
        .getClient("")
        .post(config.NodeUrl+ "/driver/exportwasldriver", getData, {
          responseType: 'blob'  // ← ADD THIS!
        });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'wasl_driver_report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return response?.data;
    } catch (error) {
      console.error('Export failed:', error);
    }
  } else {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=wasl&a=exportwasldriverexcel&cid=" +
      getData.cid +
      "&UcompanyId=" +
      getData.UcompanyId +
      "&colList=" +
      getData.colList +
      "&searchField=" +
      getData.searchField +
      "&language=" +
      lang;
  }
}


   async getWASLDriverActivity(){
    var postData={
         roleId2: Number(JSON.parse(base64_decode(Cookies.get("data"))).roleId2),
         userId:JSON.parse(base64_decode(Cookies.get("data"))).userId,
         status:1
  
    }
    console.log(postData,'postddddddata')
    var response = await postApi
        .getClient("")
        .post(config.NodeUrl+"/vehicle/getwaslactivity", {
          postData
        });
      
      this.waslactivity = response?.data.data
      console.log(response?.data.data);
     
      return response?.data;
  }
}

export default WASLDriverStore;
